import { useHudStore } from "../store/hudStore";
import type { HudView } from "../store/selectors";
import EngineerSprite from "./EngineerSprite";
import { Button } from "../design-system/components";

export default function TopBar({ v }: { v: HudView }) {
  const st = useHudStore();
  const finance = ["debt", "account", "expense"].includes(st.screen) || (st.screen === "domain" && st.domain === "Finances");
  const destinations = [
    { label: "Today", icon: "fa-solid fa-house", active: st.screen === "hud", action: st.goHud },
    { label: "Finances", icon: "fa-solid fa-wallet", active: finance, action: () => st.openDomain("Finances") },
    { label: "Progress", icon: "fa-solid fa-chart-simple", active: st.screen === "character", action: st.goCharacter },
    { label: "Vault", icon: "fa-solid fa-vault", active: st.screen === "vault", action: st.goVault },
    { label: "Settings", icon: "fa-solid fa-gear", active: st.screen === "settings", action: st.goSettings },
  ];
  return (
    <header className="topbar">
      <div className="topbar-identity">
        <button type="button" className="brand-link ds-focusable" onClick={st.goHud} aria-label="Life OS, go to today">
          <img src="/logo.png" alt="" width="32" height="32" />
          <span>Life OS</span>
        </button>
        <button type="button" className="character-link ds-focusable" onClick={st.goCharacter} aria-label={`Your progress, level ${v.level}, ${v.xpLabel}`}>
          <span className="character-sprite" aria-hidden="true"><EngineerSprite variant="idle" /></span>
          <span className="character-name">Arlou <span>Level {v.level}</span></span>
          <span className="character-xp">{v.xpLabel}</span>
        </button>
      </div>
      <div className="topbar-status">
        <div className="streak-readout" role="status" aria-label={v.streakLabel} title={v.streakLabel}>
          <i className="fa-solid fa-fire" aria-hidden="true" style={{ color: v.streakFg, animation: v.streakCaught ? "flare .9s var(--ease)" : "none" }} />
          <span>{v.streak} <span className="readout-unit">{v.streak === 1 ? "day" : "days"}</span></span>
        </div>
        <Button size="compact" className="reward-button" icon={v.claimIcon} onClick={st.claim} disabled={v.claimDisabled} title={v.claimTitle} aria-label={v.claimTitle}>
          {v.claimLabel}
        </Button>
        <Button variant="quiet" size="compact" className="sync-readout" icon={v.syncFa} onClick={st.goVault} title={v.syncTitle} aria-label={v.syncTitle} style={{ color: v.syncColor }}>{v.syncCount}</Button>
      </div>
      <nav className="app-navigation" aria-label="Primary navigation">
        {destinations.map((item) => (
          <button key={item.label} type="button" className="ds-focusable" onClick={item.action} aria-current={item.active ? "page" : undefined}>
            <i className={item.icon} aria-hidden="true" /><span>{item.label}</span>
          </button>
        ))}
      </nav>
    </header>
  );
}
